import { render, staticRenderFns } from "./FormArea.vue?vue&type=template&id=de5c96ac&scoped=true"
import script from "./FormArea.vue?vue&type=script&lang=js"
export * from "./FormArea.vue?vue&type=script&lang=js"
import style0 from "./FormArea.vue?vue&type=style&index=0&id=de5c96ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5c96ac",
  null
  
)

export default component.exports